export enum JSON_MEDIA_TYPES {
    'APPLICATION/JSON' = 'application/json',
    'TEXT/JAVASCRIPT' = 'text/javascript'
}